<template>
  <v-row class="text--primary" v-if="showEstoque">
    <v-col cols="12">
      <v-card outlined class="rounded-card">
        <v-subheader class="grey lighten-2 text--primary font-weight-bold">
          Estoque do produto
        </v-subheader>
        <px-listagem-estoque :produto-id="itemAprovacao.produto.id" />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ListagemEstoque
  from '@/modules/estoque/ListagemEstoque.vue';
import { mapGetters } from 'vuex';

export default {
  props: {
    itemAprovacao: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador', 'hasRoleAprovadorRequisicao', 'hasRoleAprovador']),
    ...mapGetters('entidade', ['hasEstoque']),
    showEstoque() {
      return this.hasEstoque && (this.hasRoleComprador
        || this.hasRoleAprovadorRequisicao || this.hasRoleAprovador);
    },
  },
  components: {
    pxListagemEstoque: ListagemEstoque,
  },
};
</script>
